import { render } from "./FormOfficeColor.vue?vue&type=template&id=1d716987&scoped=true&ts=true"
import script from "./FormOfficeColor.vue?vue&type=script&lang=ts"
export * from "./FormOfficeColor.vue?vue&type=script&lang=ts"

import "./FormOfficeColor.vue?vue&type=style&index=0&id=1d716987&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d716987"]])

export default __exports__